/**
 * Concept Archetype
 *
 * @author Daniel Lepe
 * @date 22/May/2023
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'cedes'

const baseIndex = baseController + '/index'

const imagenLogoLabel = 'Logo',
    cedeTipoLabel = 'Tipo de sede',
    claseMenu = 'Clase de menú',
    sedeTitulo = 'Nombre';

const archetype = () => {
    return [
    // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id',
        type: 'hidden'
    },
    [
        {
            key: 'cede_titulo',
            label: sedeTitulo,
            required: true,
        }
    ],
    null,
    [
        {
            key: 'cede_tipo',
            label: cedeTipoLabel,
            type: 'select',
            required: true,
            options: [
                {value: 'empresa', text: 'Empresa' },
                {value: 'escuela', text: 'Escuela'}
            ],
            default: 'escuela'
        },
        { key: 'codigo', type: 'text', label: 'Código', required: true },
    ],
    null,
    {
        key: 'imagen_logo',
        label: imagenLogoLabel,
        type: 'imageurl',
    },
    {
        key: 'imagen_fondo',
        label: 'Fondo',
        type: 'imageurl',
    },
    null,
    [
        { 
            key: 'modo', 
            type: 'select', 
            label: 'Modo', 
            options: ['Normal', 'PrePago'],
            default: 'Normal'
        },
        { 
            key: 'modo_agenda', 
            type: 'select', 
            label: 'Modo Agenda', 
            options: ['Normal', 'Múltiple'],
            default: 'Normal'
        },
    ],
    [
        {
            key: 'menu_clase',
            type: 'select',
            label: claseMenu,
            options: [
                'GENERICA',
                'COMIDAS',
            ],
            default: 'GENERICA'
        },
        {
            key: 'accesso',
            type: 'select',
            label: 'Acceso',
            options: [
                'Privado',
                'Abierto'
            ],
            default: 'Privado'
        },
    ],
    null,
    [
        {
            key: 'precio_base',
            type: 'number',
            default: 45
        }, {
            key: 'precio_premium',
            type: 'number',
            default: 50
        }
    ],
    null,
    {
        key: 'horario_limite',
        type: 'time',
        label: 'Horario Límite',
        default: '12:00:00'
    },
    null,
    {
            key: 'allow_L',
            label: 'Lunes',
            type: 'checkbox',
            default: '1'
        },
        {
            key: 'allow_M',
            label: 'Martes',
            type: 'checkbox',
            default: '1'
        },
        {
            key: 'allow_I',
            label: 'Miércoles',
            type: 'checkbox',
            default: '1'
        },
        {
            key: 'allow_J',
            label: 'Jueves',
            type: 'checkbox',
            default: '1'
        },
        {
            key: 'allow_V',
            label: 'Viernes',
            type: 'checkbox',
            default: '1'
        }
    ]
};

const captions = [
    { key: 'imagen_logo', label: imagenLogoLabel },
    { key: 'cede_titulo', label: sedeTitulo },
    { key: 'cede_tipo', label: cedeTipoLabel },
    // { key: 'precio_premium', label: 'Precio Premium' },
    // { key: 'precio_base', label: 'Precio Base' },
    { key: 'menu_clase', label: claseMenu },
    { key: 'codigo', label: 'Código' },
    { key: 'modo', label: 'Modo' },
    { key: 'modo_agenda', label: 'Modo Agenda' },
    { key: 'accesso', label: 'Acceso' },
    { key: 'horario_limite', label: 'Horario Límite' },
    { key: '_' }
]


let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

export {
    archetype,
    captions,
    baseIndex,
    automodalHandler
}
